import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataSharingService } from 'shared/services/data-sharing/data-sharing.service';
import { VendorsService } from 'shared/services/SS-vendors/vendors.service';
import * as _ from 'lodash';
import { AlertPopupService } from 'shared/services/SS-Alert/alert-popup.service';
import { environment } from 'environments/environment';
import { AppComponent } from 'app/app.component';
import { UserService } from 'shared/services/User/user.service';
import Swal from 'sweetalert2';
import { MatDialog } from '@angular/material';
import { PreviewDraftComponent } from 'shared/reusable/preview-draft/preview-draft.component';
import { SubFooterComponent } from 'shared/reusable/sub-footer/sub-footer.component';
import { SetGamesModal } from 'shared/reusable/set-games-modal/set-games-modal.component';
import { forEach } from '@angular/router/src/utils/collection';
declare var mixpanel; 
@Component({
  selector: 'app-choose-upload-plan',
  templateUrl: './choose-upload-plan.component.html',
  styleUrls: ['./choose-upload-plan.component.scss']
})
export class ChooseUploadPlanComponent implements OnInit {
  loading: boolean;
  teamId: string;
  accountId: any;
  ticketMasterData: any;
  firstStep: Boolean = true;
  secondStep: boolean;
  thirdStep: boolean;
  fourthStep: boolean;
  selectedSeasonIndex: number;
  selectedSeason: any;
  seatsOfSelectedSeasonArray: any = [];
  totalDraftPicks: number;
  seatsSelected: Boolean = false;
  selected_seats: any;
  imageURL: string = environment.URL_TEAM_IMAGES;
  eventsPerPick: Number = 1;
  seatsPerPick: number;
  isNextSeason: Boolean = false;
  isPaymentEnabled: Boolean = true;
  isGroupPrivate: Boolean = false;
  isStripeConnected: Boolean = false;
  isFullyPaid: any = null; 
  splitBetween: any = 1;
  picksPerMember;
  code: any;
  state: any;
  paymentMethodOnFile: boolean = false;
  gamesToShareCount = 0;
  totalValue = '';
  isGameDraft: boolean = true;
  splitTypeId = null;

  constructor(
    private data: DataSharingService,
    private vendorService: VendorsService,
    private alertService: AlertPopupService,
    private route: ActivatedRoute,
    private userService: UserService,
    private router: Router,
    private app: AppComponent,
    private dialog: MatDialog
  ) {
    this.route.queryParams.subscribe(params => {
      this.accountId = params.acctId,
        this.teamId = params.teamId,
        this.code = params.code,
        this.state = params.state;
    });
    this.userService.reloadUser().then(res => {
      console.log("RELOADED")
      console.log(res)

      if (res.payout_methods.length > 0) {
        this.paymentMethodOnFile = true;
      }
    })
  }

  ngOnInit() {
    this.data.changeTitle('Choose Plan');
    mixpanel.track("Viewing season plans on account", {})
    this.loading = true;
    this.selectedSeasonIndex = 0;
    this.vendorService.ticketmasterGetAccountByID(this.accountId, this.teamId).subscribe(response => {
      if (response.length !== 0) {
        this.ticketMasterData = response;
        if (this.code && this.code.length > 20 && this.state && this.state === 'ACCT_CREATED') {
          const obj = JSON.parse(localStorage.getItem('choosePlanAfterStripeCalling'));
          if (obj) {
            this.firstStep = false;
            this.secondStep = false;
            this.thirdStep = true;
            this.isPaymentEnabled = true;
            this.splitBetween = obj.splitValue;
            this.seatsPerPick = obj.seatsPerPick;
            this.totalDraftPicks = obj.totalDraftPicks;
            this.picksPerMember = obj.picksPerMember;
            this.isStripeConnected = obj.isStripeConnected;
            this.isGroupPrivate = obj.isGroupPrivate;
            this.selected_seats = obj.selected_seats;
            this.isFullyPaid = obj.is_fully_paid;
            this.customGamesSelected = obj.customGamesSelected;
            this.splitTypeId = obj.splitTypeId;
            this.showPopup();
            setTimeout(() => {
              localStorage.removeItem('choosePlanAfterStripeCalling');
            }, 100);
          } else {
            this.alertService.errorAlert('You can not refresh Page');
          }
        } else {
          localStorage.removeItem('choosePlanAfterStripeCalling');
          this.isStripeConnected = false;
        }
      } else {
        this.alertService.errorAlertWithResult('Error getting events by account ID', 'Go Back', 'new-group');
      }
      this.loading = false;
      this.app.dismissLoading();
      this.updateTotalValue();
    }, err => {
      this.loading = false;
      this.app.dismissLoading();
      this.alertService.errorAlertWithResult(err.error.message, 'Go Back', 'new-group');
    });
  }

  // Stepper clicks
  seasonSelection(){
    if(this.seatsSelected == true){
      let a = confirm("Are you sure you want to restart?")
      if(a){
        this.firstStep = true; 
        this.secondStep = false;
        this.thirdStep = false; 
        this.fourthStep  =false; 
        this.seatsSelected = null; 
      }
    }
  }
  seatBlockSelection(){
    if(this.isFullyPaid != null){
      this.firstStep = false; 
      this.secondStep = true;
      this.thirdStep = false; 
      this.fourthStep  =false;
    }
  }
  splitTypeSelection(){
    if(this.seatsSelected == true){
      this.firstStep = false; 
      this.secondStep = false;
      this.thirdStep = true; 
      this.fourthStep  =false; 
    }
  }
  finalize(){
    // if(this.selectedSeason)
    if(this.splitTypeId != null){
      this.firstStep = false; 
      this.secondStep = false;
      this.thirdStep = false; 
      this.fourthStep  =true; 
    }
  }

  selectGroup(season, index) {
    this.isNextSeason = false;
    this.firstStep = false;
    this.secondStep = true;
    this.app.toggleLoadingMsg('loading');
    const checked = season['isSelected'];
    if (checked === true) {
      this.ticketMasterData.account_summary[index]['isSelected'] = false;
      this.app.dismissLoading();
    } else {
      this.ticketMasterData.account_summary[index]['isSelected'] = true;
      _.each(this.ticketMasterData.account_summary, (accountSummarty, i) => {
        if (i !== index) {
          accountSummarty['isSelected'] = false;
        }
      });
      this.selectedSeasonIndex = index;
      this.selectedSeason = this.ticketMasterData.account_summary[this.selectedSeasonIndex];
      this.isFullyPaid = this.selectedSeason.fully_paid_for;
      console.log(this.selectedSeason);
      this.getSeatDataBySeasonIndex(index);
      this.app.dismissLoading();
    }
  }

  isCreateDisabled() {
    if (this.paymentMethodOnFile == true) {
      return false;
    }
    return !this.isStripeConnected;
  }

  selectNextSeason(season, index) {
    // NEXT SEASON 
    this.isNextSeason = true;
    this.firstStep = false;
    this.secondStep = true;
    this.app.toggleLoadingMsg('loading');
    const checked = season['isSelected'];
    if (checked === true) {
      this.ticketMasterData.account_summary[index]['isSelected'] = false;
      this.app.dismissLoading();
    } else {
      this.ticketMasterData.account_summary[index]['isSelected'] = true;
      _.each(this.ticketMasterData.account_summary, (accountSummarty, i) => {
        if (i !== index) {
          accountSummarty['isSelected'] = false;
        }
      });
      this.selectedSeasonIndex = index;
      this.selectedSeason = this.ticketMasterData.account_summary[this.selectedSeasonIndex];
      this.isFullyPaid = this.selectedSeason.fully_paid_for;
      this.getSeatDataBySeasonIndex(index);
      this.app.dismissLoading();
    }
  }


  getSeatDataBySeasonIndex(index) {
    const curSeason = this.ticketMasterData.account_summary[index];
    this.totalDraftPicks = curSeason.events_in_plan.length;
    if (this.isNextSeason == true) {
      this.totalDraftPicks = Number(curSeason.plan_information.event_count);
    }
    this.picksPerMember = Math.floor(this.totalDraftPicks / (this.splitBetween + 1));
    this.gamesToShareCount = Math.ceil(Number(this.picksPerMember) * (Number(this.splitBetween)));
    this.updateTotalValue();
    const arrayOfSeats = [];
    for (let i = 0; i < curSeason.seat_block.num_seat; i++) {
      const oneSeat = {
        section: curSeason.seat_block.section_name,
        row: curSeason.seat_block.row_name,
        seat: curSeason.seat_block.seat_num + i,
        isToggled: false
      };
      arrayOfSeats.push(oneSeat);
    }
    this.seatsOfSelectedSeasonArray = arrayOfSeats;
  }

  selectSeat(seat) {
    const checked = seat['isToggled'];
    if (checked) {
      seat['isToggled'] = false;
      // check if all other seats are checked
      this.areAllSeatsEmpty();
    } else {
      seat['isToggled'] = true;
      this.seatsSelected = true;
    }
  }

  areAllSeatsEmpty() {
    _.each(this.seatsOfSelectedSeasonArray, (seatsOfSelected) => {
      if (seatsOfSelected.isToggled) {
        this.seatsSelected = true;
      }
    });
    this.seatsSelected = false;
  }
  paymentInfo() {
    // show toolip on icon hover
  }
  startOver(){
    window.location.reload();
  }

  nextStep() {
    if (!this.seatsSelected) {
      this.alertService.errorAlertError('Please select at least one seat to continue.');
    } else {
      const newArray = _.filter(this.seatsOfSelectedSeasonArray, one => {
        return one.isToggled === true;
      });
      this.seatsPerPick = newArray.length;
      const a = this.checkSeatSelection(newArray);
      if (a) {
        this.firstStep = false;
        this.secondStep = false;
        this.thirdStep = true;
      } else {
        this.alertService.errorAlertError('You must select 2 seats next to each other.');
      }
    }
  }

  checkSeatSelection(selectedSeatsArray: any) {
    const howManySeats = selectedSeatsArray.length;
    if (howManySeats > 1) {
      for (let i = 1; i < selectedSeatsArray.length; i++) {
        const curSeat = selectedSeatsArray[i].seat;
        const prevSeat = selectedSeatsArray[i - 1].seat;
        if (curSeat !== (prevSeat + 1)) {
          return false;
        }
      }
      this.selected_seats = selectedSeatsArray;
      return true;
    } else {
      this.selected_seats = selectedSeatsArray;
      return true;
    }
  }

  decrementFriendCount() {
    if (this.splitBetween > 1) {
      this.splitBetween--;
    }
    this.updatePicksPerMember();
  }

  incrementFriendCount() {
    if (this.splitBetween >= 1 && this.splitBetween < 3) {
      this.splitBetween++;
    }
    this.updatePicksPerMember();
  }

  decrementGameToShare() {
    let minGames = Math.ceil(this.totalDraftPicks / 4);
    if (!this.isGroupPrivate && this.gamesToShareCount > minGames) {
      this.gamesToShareCount--;
      this.picksPerMember = this.gamesToShareCount;
    }
    this.updateTotalValue();
  }
  incrementGameToShare() {
    let maxGames = Math.floor(this.totalDraftPicks / 4) * 3;
    if (!this.isGroupPrivate && this.gamesToShareCount < maxGames) {
      this.gamesToShareCount++;
      this.picksPerMember = this.gamesToShareCount;
    }
    this.updateTotalValue();
  }

  updateTotalValue() {
    let oneGame = Number(this.ticketMasterData.account_summary[this.selectedSeasonIndex].events_in_plan[0]['face_value']);
    let total = Number(this.gamesToShareCount) * Number(oneGame);
    this.totalValue = total.toFixed(2);
  }

  updatePicksPerMember() {
    if (this.totalDraftPicks % (this.splitBetween + 1) != 0) {
      // uneven
      let firstMember = Math.floor(this.totalDraftPicks / (this.splitBetween + 1))
      this.picksPerMember = firstMember + "/" + (firstMember + 1);
      this.gamesToShareCount = Math.ceil(firstMember * (this.splitBetween)) + 1;
    } else {
      // even
      this.picksPerMember = (this.totalDraftPicks / (this.splitBetween + 1))
      this.gamesToShareCount = Math.ceil(this.picksPerMember * (this.splitBetween));
    }
    this.updateTotalValue();
  }
  // group type changed
  changedGroupType() {
    setTimeout(() => {
      if (!this.isGroupPrivate) {
        // if group is public, auto enable payment, set me + 1 
        this.isPaymentEnabled = true;
        this.isStripeConnected = false;
        this.splitBetween = 1;
        this.updatePicksPerMember();
        this.updateTotalValue();
      } else {
        if (this.isNextSeason == true) {
          this.isPaymentEnabled = true;
          this.isStripeConnected = false;
        } else {
          this.isPaymentEnabled = false;
          this.isStripeConnected = true;
        }
        this.updatePicksPerMember();
        this.updateTotalValue();
      }
    }, 5);
  }
  changedDraftType() {
    
  }

  editDraftType(){
    this.firstStep = false; 
    this.secondStep = false; 
    this.thirdStep = true; 
    this.fourthStep = false; 
  }

  selectDraft(){
    this.splitTypeId = 1; 
    this.isGameDraft = true; 
    this.firstStep = false; 
    this.secondStep = false; 
    this.thirdStep = false; 
    this.fourthStep = true; 
  }
  selectLottery(){
    this.splitTypeId = 2; 
    this.isGameDraft = false;
    this.firstStep = false; 
    this.secondStep = false; 
    this.thirdStep = false; 
    this.fourthStep = true; 
    this.chooseGames(); 
  }

  checkPayment() {
    if (this.isNextSeason == true) {
      this.isPaymentEnabled = true;
    }
    setTimeout(() => {
      if (this.isPaymentEnabled) {
        this.isStripeConnected = false;
      } else {
        this.isStripeConnected = true;
      }
    }, 5);
  }

  requestCall() {
    Swal.fire({
      imageUrl: 'assets/images/support.png',
      imageWidth: 100,
      imageAlt: 'Custom image',
      title: "Let us help you!",
      text: "Request a call from your dedicated Support Agent. Enter your phone number and we'll give you a call.",
      input: 'text',
      inputPlaceholder: "Phone Number",
      inputAttributes: {
        autocapitalize: 'off',
      },
      showCancelButton: true,
      confirmButtonText: 'Request a call',
      showLoaderOnConfirm: true,
      preConfirm: (phoneNumber) => {
        let a = (Number.isInteger(Number(phoneNumber)));
        if (a == true) {
          this.userService.requestGroupInfo("UPLOAD", phoneNumber).then(res => {
            Swal.fire({
              title: `Thanks! We'll be in touch with you shortly. `,
              type: "success"
            })
            return res;
          }).catch(err => {
            Swal.fire({
              title: `Hmm. Something went wrong. Try again later. `,
              type: "error"
            })
          })
        } else {
          return Swal.fire({
            type: 'warning',
            title: 'Foul!'
          })
        }
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
    })
  }

  createGroup() {

    let customEventIds = [];
    if(this.splitTypeId == 2){
      this.customGamesSelected.forEach(element => {
        customEventIds.push(element.id);
      })
    }
    let eventString = customEventIds.join();
    
    let gamesToShareCount = this.gamesToShareCount.toString(); 
    if(this.splitTypeId == 1){
      gamesToShareCount = '';
    }

    this.app.toggleLoadingMsg('Creating Group');
    const data = {
      res_ref: this.ticketMasterData.res_ref,
      plan_ref: this.ticketMasterData.account_summary[this.selectedSeasonIndex].plan_ref,
      group_size: Number(this.splitBetween + 1),
      first_seat: this.selected_seats[0]['seat'],
      last_seat: this.selected_seats[this.selected_seats.length - 1].seat,
      num_seats: this.selected_seats.length,
      payment_enabled: this.isPaymentEnabled,
      next_season: this.isNextSeason,
      games_to_share_count: gamesToShareCount,
      split_type_id: this.splitTypeId,
      custom_games_selected: eventString,
      flag_string: this.flagString
    };
    
    if (this.isGroupPrivate === false) {
      data['group_type'] = 'PUBLIC';
    } else {
      data['group_type'] = 'PRIVATE';
    }
    this.vendorService.uploadTicketmaster(data).subscribe(res => {
      // if its a group object, hit the waiting room
      if (res.group) {
        this.router.navigate(['/groups/waiting-room'], { queryParams: { groupId: res.group.group_id } });
      }
      this.app.dismissLoading();
    }, err => {
      this.app.dismissLoading();
      this.alertService.errorAlertError(err.json().error.message);
    });
  }

  showPopup() {
    Swal.fire({
      title: 'Connected',
      type: 'success',
      text: 'Successfully linked your Stripe Account',
      showCancelButton: false,
      allowOutsideClick: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Create Group',
    }).then((result) => {
      if (result.value) {
        this.createGroup();
      }
    });
  }

  stripeSetup() {
    const clientKey = environment.STRIPE_CLIENT_KEY;
    const redirect_uri = window.location.href.split('?')[0] + '?acctId=' + this.accountId + '&teamId=' + this.teamId;
    const firstName = this.userService.user.firstName;
    const lastName = this.userService.user.lastName;
    const email = this.userService.user.email;
    const obj = {
      'accountId': this.accountId,
      'teamId': this.teamId,
      'splitValue': this.splitBetween,
      'seatsPerPick': this.seatsPerPick,
      'totalDraftPicks': this.totalDraftPicks,
      'picksPerMember': this.picksPerMember,
      'isStripeConnected': true,
      'isGroupPrivate': this.isGroupPrivate,
      'selected_seats': this.selected_seats,
      'is_fully_paid': this.ticketMasterData.account_summary[this.selectedSeasonIndex].fully_paid_for,
      'customGamesSelected' : this.customGamesSelected,
      'splitTypeId' :this.splitTypeId
    };
    localStorage.setItem('choosePlanAfterStripeCalling', JSON.stringify(obj));
    // tslint:disable-next-line:max-line-length
    window.open(`https://connect.stripe.com/express/oauth/authorize?redirect_uri=${redirect_uri}&client_id=${clientKey}&state=ACCT_CREATED&stripe_user[first_name]=${firstName}&stripe_user[last_name]=${lastName}&stripe_user[email]=${email}`,
      '_self');
  }

  previewDraft() {
    const dialogRef = this.dialog.open(PreviewDraftComponent, {
      data: {
        events: this.ticketMasterData.account_summary[this.selectedSeasonIndex].events_in_plan,
        teamDescription: this.ticketMasterData.account_summary[this.selectedSeasonIndex].plan_information.description
      },
      width: '70%',
    });
  }

  customGamesSelected = []; 
  flagString = '';
  chooseGames(){
    const dialogRef = this.dialog.open(SetGamesModal, {
      data: {
        events: this.ticketMasterData.account_summary[this.selectedSeasonIndex].events_in_plan,
        teamDescription: this.ticketMasterData.account_summary[this.selectedSeasonIndex].plan_information.description
      },
      width: '70%',
    });

    dialogRef.afterClosed().subscribe(res => {
      this.customGamesSelected = res['selectedGames'];
      this.gamesToShareCount = res['selectedGameCount'];
      let totalValue = res['total'];
      this.totalValue = Number(totalValue * this.selected_seats.length).toString(); 
      this.ticketMasterData.account_summary[this.selectedSeasonIndex].events_in_plan = res['rawEvents'];
      this.flagString  = res['flagString'];
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/choose-upload-plan/choose-upload-plan.component.ts